// src/modules/app-views/offers/pages/Document/components/OffersDocumentCardHeaderColumn1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { BorderlessTableOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import { copyToClipboard } from 'utils/copyToClipboard';
import CursorPointer from 'components/JarvislyComponents/CursorPointer';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const OffersDocumentCardHeaderColumn1 = ({
  showDocumentCode = true,
  ...record
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const docCode =
    record?._metadata?.__documentCode?.toUpperCase() ||
    (record?._id && `1.${record?._id?.slice(-6)}`);

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleCopyId = () => {
    if (!record?._id) return;
    copyToClipboard(record._id, 'document_id_copied');
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'documentCode',
      icon: <BorderlessTableOutlined />,
      label: docCode ? <CursorPointer>{docCode?.toString()?.toUpperCase()}</CursorPointer> : null,
      tooltipText: translateX('document_code'),
      tooltipPlacement: 'right',
      onClick: handleCopyId,
      hidden: !showDocumentCode,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items?.filter(i => i?.label && !i.hidden)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default OffersDocumentCardHeaderColumn1;
